import React, { useEffect, useState } from 'react'
import { getUser } from '../../../actions/session'
import Select from 'react-select';
import Container from '../../common/application_container'
import Axios from 'axios';
import { ALL_ACCOUNT_LIST, FIND_ROUTE_CREATE_API } from '../../../config/rest_endpoints';
import { Notifications } from '../../common/notification';
import Table from './table';
import CustomLoader from '../../common/loader'




const FindRouteIndex = () => {
    const [User] = useState(getUser())
    const [isLoad, setisLoad] = useState(false)
    const [state, setState] = useState({
        destination:'17027953317',
        source:'12174609558',
    })

    const [systemTypes] = useState([
        { label: 'True-LCR', value:'True-LCR'},
        { label: 'LCR Considering Carrier Holdtime', value: 'LCR Considering Carrier Holdtime' },
    ])

    const [selectSystem, setSelectSystem] = useState({ label: 'True-LCR', value:'True-LCR'})

    const [accountOptions, setAccountOptions] = useState([])
    const [selectAccount, setSelectAccount] = useState('')

    const [tableData, setTableData] = useState([])



    useEffect(() => {getAcccountList()},[])

    const getAcccountList = () => {
        setisLoad(true)
        var headers = { 'Authorization': "Bearer " + User.token }
        Axios.get(ALL_ACCOUNT_LIST, { headers }).then(res => {
            if (res) {
                var resp = res.data.data
                console.log(`resp`, resp)
                const list = resp.map(row => {
                    row['label'] = row['accountName']
                    row['value'] = row['id']
                    return row
                })
                setAccountOptions(list)
                setisLoad(false)

            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            setisLoad(false)
        })
    }

    const handleInput = (e) => {
        const {name,value} = e.target
        setState(prev =>({
            ...prev,
            [name]:value
        }))
    }

    const submitData = () => {
        const payload = {
            "destination": state.source,
            "source": state.destination,
            "systemLCRType": selectSystem.value,
            "accountID":selectAccount.value
        }
        console.log(`payload`, payload)
        setisLoad(true)
        var headers = { 'Authorization': "Bearer " + User.token }
        Axios.post(FIND_ROUTE_CREATE_API, payload, { headers }).then(res => {
            if (res) {
                console.log(`resp`, res)
                var resp = res.data
                setTableData(resp)
                console.log('resp', resp)
                setisLoad(false)
                Notifications.notify("Successfully created the ratedeck", "Created", "success")
            }
        }).catch(err => {
            const msessage = err.response.data.message
            Notifications.notify(msessage, "Failed", "error")
            setisLoad(false)
        })
    }

    const renderTableHearder = () => {
        const data = tableData.data || []
        const {customerRate,destinationLRN,destinationState,jurisdiction,sourceState} = tableData.data || ''
        console.log('first', customerRate)
        console.log('tableData', tableData)
        if (Object.keys(data).length) {
            return (
                <tr>
                    <td>{sourceState}</td>
                    <td>{customerRate}</td>
                    <td>{destinationLRN}</td>
                    <td>{destinationState}</td>
                    <td>{jurisdiction}</td>
                </tr>
            )
        } 
        else {
            return (
                <div className="ml-3 mt-3">
                <div className="dataTables_info " id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
            )
        }
       
    }

    return (
        <Container title="Find Route" title1='Table' icon="fa fa-credit-card">
            <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body">
                <div className="card-header  header-elements-inline p-0 py-1 mb-1">
                    <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"></h5>
                </div>
                <div className="d-flex justify-content-start flex-wrap bg-light rounded border p-0 mb-2">
                        <div className="py-2 px-3 mb-1">
                            <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">Source:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Source"
                                    name="destination"
                                    value={state.destination}
                                    onChange={handleInput}
                                />
                        </div>
                        <div className="py-2 px-3 mb-1">
                            <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">Destination:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Destination"
                                    name="source"
                                    value={state.source}
                                    onChange={handleInput}
                                />
                        </div>
                        <div className="py-2 px-3 mb-1">
                            <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">System Type:</label>
                                <Select
                                    value={selectSystem}
                                    onChange={(selectSystem) => setSelectSystem(selectSystem)}
                                    options={systemTypes}
                                    className="w-27em"
                                />
                        </div>
                        <div className="py-2 px-3 mb-1">
                            <label  style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">Account Select:</label>
                                <Select
                                    value={selectAccount}
                                    onChange={(selectAccount) => setSelectAccount(selectAccount)}
                                    options={accountOptions}
                                    className="w-27em"
                                />
                        </div>
                        <div className="py-2 px-3 mb-1">
                            <button type="submit" className="btn btn-success btn-sm main-button mt-4" onClick={submitData}>
                                Submit form <i className="ph-paper-plane-tilt ms-2"  />
                            </button>
                        </div>
                </div>
            </div>
            <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card ">
                <div className="card-header">

                    <div className="datatable-scroll" style={{ overflowX: 'auto' }}>
                        <table className="table-style table table-striped dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                            <thead>
                                <tr className='stickeyHeader table-heading-style'>
                                    <th>Source State</th>
                                    <th>Customer Rate</th>
                                    <th>Destination LRN</th>
                                    <th>Destination State</th>
                                    <th>Jurisdiction</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoad ? <CustomLoader/> : (renderTableHearder())}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="card-body">
                    <Table info={tableData} loading={isLoad}/>
                </div>
            </div>

        </Container>
    )
}

export default FindRouteIndex